import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "help-support-modal__section help-support-modal__section--intro" }
const _hoisted_2 = { class: "help-support-modal__actions" }

import Dialog from 'primevue/dialog';

interface Props {
    visible: boolean;
    canReplayTour?: boolean;
}

const supportEmail = 'creditors@setforth.com';

export default /*@__PURE__*/_defineComponent({
  __name: 'HelpSupportModal',
  props: {
    visible: { type: Boolean },
    canReplayTour: { type: Boolean }
  },
  emits: ["update:visible", "cancel", "replayTour"],
  setup(__props: any, { emit: __emit }) {

/* eslint-env vue/setup-compiler-macros */
// import { computed } from 'vue'; 
const props = __props;

const emit = __emit;

// const documentationUrl = computed(() => (process.env.VUE_APP_HELP_DOCUMENTATION_URL ?? 'https://creditorportalservice-753193062349.us-central1.run.app/docs/api#/').trim());
// const trainingVideoUrl = computed(() => (process.env.VUE_APP_HELP_TRAINING_VIDEO_URL ?? 'https://drive.google.com/file/d/1pSbKjYgZjh55ok6BFcshXzCaHsHZhp6M/preview').trim());
const supportEmailHref = `mailto:${supportEmail}`;

function close() {
    emit('update:visible', false);
    emit('cancel');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: props.visible,
    modal: "",
    blockScroll: true,
    dismissableMask: true,
    closable: false,
    draggable: false,
    pt: {
            root: { class: 'help-support-modal' },
            header: { style: { display: 'none' } },
            content: { class: 'help-support-modal__content' },
            footer: { style: { display: 'none' } },
            mask: { class: 'help-support-modal__mask' },
        },
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (emit('update:visible', $event)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", { class: "help-support-modal__topbar" }, [
        _createElementVNode("button", {
          type: "button",
          class: "help-support-modal__close",
          "aria-label": "Close help and support modal",
          onClick: close
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("i", {
            class: "fa-solid fa-xmark",
            "aria-hidden": "true"
          }, null, -1)
        ]))])
      ]),
      _createElementVNode("section", _hoisted_1, [
        _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "help-support-modal__heading" }, "New to FORTH Creditor Portal?", -1)),
        _cache[4] || (_cache[4] = _createElementVNode("p", { class: "help-support-modal__copy" }, " Check out our onboarding tour for new users. ", -1)),
        _createElementVNode("div", _hoisted_2, [
          (__props.canReplayTour)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "help-support-modal__action",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('replayTour')))
              }, " Replay product tour "))
            : _createCommentVNode("", true)
        ])
      ]),
      _cache[8] || (_cache[8] = _createElementVNode("span", {
        class: "help-support-modal__divider",
        "aria-hidden": "true"
      }, null, -1)),
      _createElementVNode("section", { class: "help-support-modal__section help-support-modal__section--support" }, [
        _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "help-support-modal__heading" }, "Contact Our Support", -1)),
        _createElementVNode("p", { class: "help-support-modal__support-copy" }, [
          _cache[6] || (_cache[6] = _createTextVNode(" If you have any questions, comments or concerns please contact ", -1)),
          _createElementVNode("span", { class: "help-support-modal__support-line" }, [
            _cache[5] || (_cache[5] = _createTextVNode(" FORTH Creditor Support Team at ", -1)),
            _createElementVNode("a", {
              href: supportEmailHref,
              class: "help-support-modal__support-link"
            }, _toDisplayString(supportEmail))
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})